import Vue from 'vue'
import App from './App.vue'
import router from "@/routes";
import store from '@/store/index'
import Cookies from 'js-cookie'
import '@/components/EChart/registe-echart'

import moment from 'moment'
import 'moment/locale/zh-cn';
moment.locale('zh-CN')

// // 启用ARMS埋点
// import createArms from '@/utils/arms.js'
// createArms()

import '@/components/antd/lazy_antd'
import '@/assets/styles/index.styl'
import '@/assets/styles/tailwind.css'

if(process.env.NODE_ENV === 'development') {
  Cookies.set('lsmyToken', process.env.VUE_APP_LOCAL_TOKEN)
  Cookies.set('token', process.env.VUE_APP_LOCAL_TOKEN)
}

Vue.config.productionTip = false

// 注册全局组件
import LinSpin from '@/components/LinSpin/index.vue'
import LinTable from "@/components/LinTable/LinTable";
import LinTableQuery from "@/components/LinTableQuery/LinTableQuery";
import CollapseButtons from "@/components/CollapseButtons/CollapseButtons";
import LocaleProviderZh from '@/components/LocaleProviderZh/index'
import LinDrawer from '@/components/LinDrawer/index'
import LinTextarea from '@/components/LinTextarea/index'
import SvgIcon from '@/components/SvgIcon/index'
import LinAvatar from '@/components/LinAvatar/index'
import LinSelect from '@/components/LinSelect/index'
import DictSelect from '@/components/DictSelect/index'
import AdvancedSearch from '@/components/AdvancedSearch/newAdvancedSearch.vue'
import LinUpload from '@/components/DUpLoadFile/uploadFileBtn'
import LinRangePicker from '@/components/LinRangePicker/index'
import QuestionTooltip from '@/components/QuestionTooltip/index'
import LinExportBtn from '@/components/ExportBtn/index'
import LinPageLayout from '@/components/LinPageLayout/index'

import '@/assets/import-svg-icon'

Vue.component(LinSpin.name, LinSpin)
Vue.component(LinTable.name, LinTable)
Vue.component(LinTableQuery.name, LinTableQuery)
Vue.component(CollapseButtons.name, CollapseButtons)
Vue.component(LocaleProviderZh.name, LocaleProviderZh)
Vue.component(SvgIcon.name, SvgIcon)
Vue.component(LinDrawer.name, LinDrawer)
Vue.component(LinTextarea.name, LinTextarea)
Vue.component(LinAvatar.name, LinAvatar)
Vue.component(LinSelect.name, LinSelect)
Vue.component('LinDictSelect', DictSelect)
Vue.component('LinAdvancedSearch', AdvancedSearch)
Vue.component('LinUpload', LinUpload)
Vue.component('LinRangePicker', LinRangePicker)
Vue.component('QuestionTooltip', QuestionTooltip)
Vue.component('LinExportBtn', LinExportBtn)
Vue.component('LinPageLayout', LinPageLayout)

// 注册 v-id 指令
import AutoIdPlugin, { antDHandle } from '@/utils/directive/id.js'
import { parentWindowEventBus } from './assets/js/window-event-bus';
Vue.use(AutoIdPlugin, {
  customHandle: (...params) => {
    antDHandle(...params)
  }
})

// 注册 v-permission 指令
import permissionDirective from '@/utils/directive/permission'
Vue.directive('permission', permissionDirective)

// 配置axios
import instance from "@/utils/axios";
import client from "@/utils/client";
Vue.prototype.$axios = instance
Vue.prototype.client = client
Vue.prototype.$client = client

// 添加oss图片参数函数
import ossImgParams from '@/utils/ossImgParams.js'
Vue.prototype.$ossImgParams = ossImgParams

// 添加链接协议转换函数
import switchProtocol from '@/utils/switchProtocol.js'
Vue.prototype.$switchProtocol = switchProtocol

// 添加通用表单验证函数
import { $rule } from '@/utils/formValidators'
Vue.prototype.$rule = $rule

// 注册 uploader 组件
import uploader from 'vue-simple-uploader'
Vue.use(uploader)

// 添加 v-tippy 指令
import VueTippy, { TippyComponent } from "vue-tippy";
Vue.use(VueTippy, {
  directive: 'title',
  animation: 'fade',
  arrow: true,
  interactive: true,
  delay: [300, 20],
  boundary: 'window'
});
Vue.component("tippy", TippyComponent);

function initVue() {
  new Vue({
    router,
    store,
    render() {
      return <LocaleProviderZh>
        <App />
      </LocaleProviderZh>
    },
  }).$mount('#app')
}

if (window.location.href.includes('useInIframe')) {
  parentWindowEventBus.$emit('loaded')
  parentWindowEventBus.$on('set-token', (data) => {
    console.log('接收 set-token', data)

    Cookies.set('lsmyToken', data.lsmyToken)

    initVue()
  })
} else {
  initVue()
}
